import React from 'react'
import { TextButtonView } from 'components'

export default () => <TextButtonView label={'Go Back'} />
